// THE single source of truth for the dual-content-system decision: a
// tutorial with a non-empty `htmlCode` renders that freeform HTML/CSS/JS
// page; otherwise it renders the historical `contentBlocks`. Every screen
// (Editor Preview, detached preview, public Detail, Console) must go through
// this helper -- never a local `if (tutorial.htmlCode)` truthy check, so a
// value like "   " (whitespace-only) can never accidentally flip a tutorial
// into HTML mode.
export const hasTutorialHtmlCode = (tutorial) =>
  typeof tutorial?.htmlCode === "string" && tutorial.htmlCode.trim().length > 0;

export const getHowWeDoItRenderMode = (tutorial) => (hasTutorialHtmlCode(tutorial) ? "html" : "blocks");
